import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Divider } from 'antd'
import styled, { css } from "styled-components";
import { THEME } from 'Util/constants';
import DropDown from './DropDown';
import Search from './Search';
import NewBuyer from './NewBuyer';
import Delete from './Delete';
import ProcessBuyer from './ProcessBuyer';
import NewDocument from './NewDocument';
import BuyerAction from './BuyerAction';
import ExtraFilters from './ExtraFilters';
import Edit from './Edit';

const Container = styled.div`
    border: solid 1px #ccc;
    padding: 10px 15px;
    margin: 10px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

function TableFilter(props) {

    return (
        <Container>
            <DropDown />
            <Search />
            <NewBuyer />
            <Delete />
            <ProcessBuyer />
            <NewDocument />
            <BuyerAction />
            <ExtraFilters data={props.data} column={props.column}/>
        </Container>
    )
}

TableFilter.propTypes = {
}

export default TableFilter